import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Icons} from '../../../model/icon';
import {ButtonComponent} from '../button/button.component';
import {NgForOf, NgIf} from '@angular/common';
import {TextsComponent} from '../texts/texts.component';
import {text} from '../../../functions/localization';
import {ArrowComponent} from '../arrow/arrow.component';
import {ToursArray} from '../../../model/tour';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Text} from '../../../model/text';
import {ThemeService} from '../../../services/theme.service';
import {Card, CardsArray} from '../../../model/cards';
import {MainBusyBeeComponent} from '../../pages/main/items/main-busy-bee/main-busy-bee.component';
import {FeedbackService} from '../../../services/feedback-service';
import {scrollUp} from '../../../functions/scroll-up';
import {Router} from '@angular/router';

@Component({
  selector: 'app-accordion-slider',
  imports: [
    ButtonComponent,
    NgForOf,
    TextsComponent,
    ArrowComponent,
    NgIf,
    MainBusyBeeComponent
  ],
  templateUrl: './accordion-slider.component.html',
  standalone: true,
  styleUrl: './accordion-slider.component.scss'
})
export class AccordionSliderComponent implements AfterViewInit, OnInit {
  @ViewChild('containerSlider', { static: false }) containerSlider!: ElementRef;
  @ViewChild('accordionSlider', { static: false }) accordionSlider!: ElementRef<HTMLDivElement>;

  constructor(private deviceService: DeviceDetectorService,
              public themeService: ThemeService,
              public feedValue: FeedbackService,
              private router: Router,) {}

  containerWidth: number = 0;
  elWidth: number = 0;
  elWidthExpanded: number = 0;
  elWidthCollapsed: number = 0;
  countEl: number = 4;
  activeIndex: number = -1;
  scrollProgress: number = 0;
  scrollCount: number = 0;

  isMobile: boolean = false;

  items = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6', 'Item 7', 'Item 8', 'Item 9', 'Item 10'];

  texts: Text[] = [
    {text: ['Сервисы в аэропортах ', 'Airport Services '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['мира ', 'Worldwide']},
  ];

  cards: Card[] = [
    {
      id: 6,
      title: ['Fast Track', 'Fast Track'],
      text: [
        'Когда время дороже всего. Приоритетный проход без ожидания — больше комфорта, меньше суеты, максимум впечатлений с первых минут поездки',
        'When time is your most valuable asset. Priority passage with no waiting — more comfort, less hassle, and maximum enjoyment from the very first moments of your trip'
      ],
      img: '/app/assets/images/bg/airMan.jpg',
      style: '',
      cssStyle: '',
      button: true,
      feedValue: [{text: ['VIP-сервисы в аэропортах', 'Airport VIP Services']}],
      anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
      link: '/feedback'
    },
    {
      id: 7,
      title: ['Meet+Greet', 'Meet+Greet'],
      text: ['Встреча пассажира у самолета и сопровождение до выхода из аэропорта или VIP-зала', 'Meeting the passenger at the plane and escorting them to the exit from the airport or VIP lounge'],
      img: '/app/assets/images/red-girls.svg',
      style: '',
      button: true,
      feedValue: [{text: ['VIP-сервисы в аэропортах', 'Airport VIP Services']}],
      anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
      link: '/feedback'
    },
    {
      id: 8,
      title: ['Трансфер премиум-класса', 'Premium Transfer'],
      text: ['Предоставление автомобилей высокого класса для поездок из аэропорта или внутри терминала', 'Provision of high-end cars for trips from the airport or inside the terminal'],
      img: '/app/assets/images/premium-car.svg',
      style: '',
      button: true,
      feedValue: [{text: ['VIP-сервисы в аэропортах', 'Airport VIP Services']}],
      anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
      link: '/feedback'
    },
    // {
    //   id: 9,
    //   title: ['Премиальные залы ожидания', 'Premium Waiting Rooms'],
    //   text: ['Элегантный дизайн, разнообразное меню и дополнительные услуги для максимального комфорта', 'Elegant design, varied menu and additional services for maximum comfort'],
    //   img: '/app/assets/images/premium-waiting.svg',
    //   style: '',
    //   button: true,
    //   anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    // link: '/feedback'
    // },
    {
      id: 10,
      title: ['Персональное сопровождение', 'Personal Assistance'],
      text: ['Личный ассистент, готовый выполнить любые запросы пассажира, включая бронирование отелей, ресторанов и мероприятий', 'A personal assistant who is ready to fulfill any passenger\'s requests, including booking hotels, restaurants and events.'],
      img: '/app/assets/images/bg/manWomanAir.jpg',
      style: '',
      button: true,
      feedValue: [{text: ['VIP-сервисы в аэропортах', 'Airport VIP Services']}],
      anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
      link: '/feedback',
      backgroundPosition: '-325px'
    },
    {
      id: 11,
      title: ['Приватные люксы', 'Private Suites'],
      text: ['Полностью изолированные комнаты с индивидуальным обслуживанием, обеспечивающие максимальную приватность и комфорт', 'Fully isolated rooms with individual service, providing maximum privacy and comfort'],
      img: '/app/assets/images/private-luxes.svg',
      style: '',
      button: true,
      feedValue: [{text: ['VIP-сервисы в аэропортах', 'Airport VIP Services']}],
      anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
      link: '/feedback'
    },
  ]

  ngAfterViewInit() {
    this.containerWidth = this.containerSlider?.nativeElement.children[0].offsetWidth;
    setTimeout(() => {
      if (this.isMobile) {
        this.elWidthExpanded = this.containerWidth;
        this.elWidthCollapsed = this.containerWidth ;
        this.elWidth = this.elWidthExpanded;
      } else {
        this.elWidthExpanded = this.containerWidth / this.countEl;
        this.elWidthCollapsed = this.elWidthExpanded - this.elWidthExpanded / ( this.countEl - 1);
        this.elWidth = this.elWidthExpanded;
      }
    });
  }

  openFeedback(card?: Card) {
    let feedbackTexts: Text[] = [];

    if (card && card.feedValue) {
      // Если передана конкретная карточка, используем ее данные
      feedbackTexts = card.feedValue;
    } else {
      // Или используем дефолтные данные
      feedbackTexts = [
        {text: ['VIP-сервисы в аэропортах', 'Airport VIP Services']} // <-- Обратите внимание: второй текст должен быть 'Airport VIP Services' а не 'VIP Airport Services'
      ];
    }

    this.feedValue.setFeedbackValue(feedbackTexts);
    scrollUp();
    this.router.navigate([ '/feedback' ]).then(r => r);
  }

  ngOnInit() {
    if (window.innerWidth < 576) {
      this.isMobile = true;
      this.countEl = this.isMobile ? 1 : 4;
      this.texts = [
        {text: ['Premium ', 'Premium '], textTransform: 'uppercase'},
        {text: ['care', 'care'], fontFamily: 'pd', fontStyle: 'italic', textTransform: 'uppercase'},
      ]
    }
  }

  getBackground(img: string){
    return `background-image: url("${img}")`;
  }

  setWidthEl(i: number) {
   let w;
    if (!this.isMobile){
      if (this.activeIndex > -1 ) {
        if (i == this.activeIndex) {
          w = this.containerWidth / (this.isMobile ? 2 : 2);
        } else {
          if (i >= this.scrollProgress && i <= this.scrollProgress + this.countEl - 1) {
            w = this.elWidthCollapsed;
          } else {
            w = this.elWidthExpanded;
          }
        }
      } else {
        w = this.elWidth;
      }
    } else {
      w = this.elWidthExpanded;
    }
   return `width: calc(${w}px - 20px);`;
  }


  mouseOver(i: number) {
    if (!this.isMobile) {
      this.activeIndex = i;
      this.accordionSlider.nativeElement.scrollLeft = (this.containerWidth / this.countEl) * this.scrollProgress;
      this.elWidth = this.elWidthCollapsed;
    }

  }
  mouseLeave(){
    if (!this.isMobile) {
      this.activeIndex = -1;
      this.elWidth = this.elWidthExpanded;
    }
  }


  turnLeft() {
    this.activeIndex = -1;
    this.scrollProgress > 0 ? this.scrollProgress-- : this.scrollProgress;
    this.accordionSlider.nativeElement.scrollLeft -= this.containerWidth / this.countEl;
    if (this.scrollCount > 0) {
      this.scrollCount--;
    }
  }

  turnRight() {
    this.activeIndex = -1;
    this.scrollProgress < (this.items.length - this.countEl - 1) ? this.scrollProgress++ : this.scrollProgress;
    this.accordionSlider.nativeElement.scrollLeft += this.containerWidth / this.countEl;
    if (this.scrollCount < (this.cards.length - 3) ) {
      this.scrollCount++;
    }
  }

  protected readonly Icons = Icons;
  protected readonly text = text;
  protected readonly CardsArray = CardsArray;
}
